module.exports = __webpack_public_path__ + "app-static/img/p_09.340902b0.jpg";